module.exports = __webpack_public_path__ + "static/media/GoCoderzPopup-01.ae3bcad1.jpg";